import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'actions/appAction';

import { LOGOUT_COMPLETED } from 'constants/amplitude/AmplitudeEvents';
import { FROM } from 'constants/amplitude/AmplitudeParamName';
import { LOGIN, LOGOUT } from 'constants/UrlConstants';

import amplitude from 'amplitude-js';
import { usePageMessages } from 'hooks/selectors';

import PopupButton from '../../common/Popup/PopupButton';
import SimplePopup from '../../common/Popup/SimplePopup';
import { amplitudeLogout } from '../../utils/AmplitudeUtils';

const LogoutPopup = (props) => {
    const { sideBarMenu_logout: logoutTitle } = usePageMessages();

    const logout = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        props.popupRef.current?.close();
        fetch('/logout', { method: 'GET' })
            .then((response) => {
                if (response.ok) {
                    if (props.fromFlow) {
                        amplitude.getInstance().logEvent(LOGOUT_COMPLETED, { [FROM]: props.fromFlow });
                    }
                    window.history.pushState(null, '', LOGIN);
                    window.location.replace('/');
                    amplitudeLogout();
                }
            })
            .catch((error) => {
                console.warn(error);
                props.toggleSpinner(false);
                return null;
            });
        props.removeErrorMessage?.();
    };

    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton href={LOGOUT} iconName="power" text={props.logout || logoutTitle} onClick={(e) => logout(e)} />
        </SimplePopup>
    );
};
export default connect(null, { toggleSpinner })(LogoutPopup);
